import React, { useEffect } from "react";
import { BundleInterface } from "src/store/community/bundlesSlice";

import { Button, Form, Input, Radio, Switch } from "antd";
import FileDropzone from "src/componets/FileDropzone";

interface propsInterface {
  params?: BundleInterface | undefined;
  onFinish: Function;
}

const _Form = ({ params, onFinish }: propsInterface) => {
  const [form] = Form.useForm();
  const platform = Form.useWatch('platform', form);

  useEffect(() => {
    form.resetFields();
  }, [params, form]);

  return (
    <Form
      form={form}
      onFinish={values => onFinish(values)}
      layout="vertical"
      className='v-form'
      initialValues={params}
    >
      <FileDropzone name='icon' label='Icon' preview={params?.icon_url} />

      <Form.Item name='app_id' noStyle>
        <Input type="hidden" />
      </Form.Item>

      <Form.Item name='name' label="Name">
        <Input disabled={!!params?.id} />
      </Form.Item>

      <Form.Item name='version' label="Version">
        <Input />
      </Form.Item>

      <Form.Item label="Environment" name='prod' valuePropName='checked'>
        <Switch
          checkedChildren='production'
          unCheckedChildren='development'
        />
      </Form.Item>

      <Form.Item label="Platform" name='platform'>
        <Radio.Group>
          <Radio value='ios'>ios</Radio>
          <Radio value='android'>android</Radio>
        </Radio.Group>
      </Form.Item>

      {platform !== 'android' && (
        <>
          <Form.Item name='shared_secret' label="Shared Secret">
            <Input />
          </Form.Item>

          <h6 className="v-content-label o-sm">
            StoreKit2 API Keys {' '}
            <a href="https://developer.apple.com/documentation/StoreKit/generating-jws-to-sign-app-store-requests#Get-your-key-ID-and-issuer-ID-from-App-Store-Connect" target="_blank" rel="noreferrer" style={{ fontWeight: 400 }}>
              docs
            </a>
          </h6>

          <FileDropzone name='app_store_connect_api_private_key' label='Private Key (.p8)' preview={params?.app_store_connect_api_private_key_url || undefined} />

          <Form.Item name='app_store_connect_api_key_id' label="Key ID">
            <Input />
          </Form.Item>

          <Form.Item name='app_store_connect_api_issuer_id' label="Issuer ID">
            <Input />
          </Form.Item>
        </>
      )}

      {platform === 'android' && (
        <>
          <h6 className="v-content-label o-sm">Google Play Service Account</h6>

          <Form.Item name='google_iss' label="Service Account Email (ISS)">
            <Input />
          </Form.Item>

          <Form.Item name='google_rsa_private_key' label="RSA Private Key">
            <Input.TextArea rows={4} />
          </Form.Item>
        </>
      )}

      <Form.Item>
        <Button className="v-btn v-btn-primary" type="primary" htmlType="submit">
          Submit
        </Button>
      </Form.Item>
    </Form>
  )
}

export default _Form;
